<template>
  <div @click="onClick($event)" class="informative-card">
    <div class="informative-card__top">
      <img :src="informative.image" alt="Imagem do Informativo" />
    </div>
    <div class="informative-card__bottom">
      <div class="title">{{ informative.title }}</div>
      <div class="description">
        {{ informative.headline }}
        <p>
          <b-icon size="is-small" icon="calendar"></b-icon>
          {{ informative.datetime | date('DD/MM/YYYY [às] HH:mm') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'informative-card',
  props: ['informative'],
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.informative-card {
  padding-top: 30px;
  max-width: 270px;

  &__top {
    position: relative;
    overflow: visible;

    img {
      width: 270px;
      height: 200px;
      border-radius: 12px;
      object-fit: fill;
    }
  }

  &__bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 10px;
    border-left: 8px solid var(--color-primary);
    padding: 12px;
    min-height: 90px;

    .title {
      font-size: 1.2em;
      font-weight: 400;
      margin-bottom: 8px;
      text-transform: uppercase;
    }

    .description {
      font-size: 0.8em;
      color: var(--color-text-light);
      white-space: normal;
      p {
        margin-top: 10px;
      }
    }
  }
}
</style>
